import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-tools',
  imports: [ReactiveFormsModule],
  templateUrl: './tools.component.html',
  styleUrl: './tools.component.scss'
})
export class ToolsComponent {

  toolsForm: FormGroup;
  message: string = '';
  response: string = '';

  constructor(private fb: FormBuilder, private http: HttpClient, private route: ActivatedRoute, private router: Router) {
    this.toolsForm = this.fb.group({
      password: ['', Validators.required],
      preferenceId: ['', Validators.required],
      paymentId: ['', Validators.required]
    });
  }
  ngOnInit(): void {
  }

  encrypt() {
    this.http.post<any>(`${environment.apiUrl}/encrypt`,
      { password: this.toolsForm.controls['password'].value },
      { withCredentials: true }).subscribe({
        next: (response) => {
          this.message = response.hashedPassword;
        },
        error: (err) => {
          this.message = err.message;
        }
      });
  }

  checkearPayment() {
    this.http.get(`${environment.apiUrl}/mercadopago/payment/${this.toolsForm.controls['paymentId'].value}`, { withCredentials: true })
      .subscribe({
        next: (payment) => {
          this.response = JSON.stringify(payment, null, 2);
        },
        error: (err) => {
          this.response = err.message;
        }
      });
  }

  chechearPreference() {
    this.http.get(`${environment.apiUrl}/mercadopago/preference/${this.toolsForm.controls['preferenceId'].value}`, { withCredentials: true })
      .subscribe({
        next: (preference) => {
          this.response = JSON.stringify(preference, null, 2);
        },
        error: (err) => {
          this.response = err.message;
        }
      });
  }

  clear() {
    this.message = '';
    this.response = '';
    this.toolsForm.reset();
  }

}

